import React, { PureComponent, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faCheckSquare,
  faCircleNotch,
  faCaretDown,
  faChevronDown,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import {
  faSquare,
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  loadSubscriptions,
} from '../../actions/data';
import i18n from '../../i18n';
import TabFrame from '../TabFrame/TabFrame';
import SingleSubscription from '../SingleSubscription/SingleSubscription';
import './App.css';

const INVALID_EMAIL = i18n.t('email-invalid');

// Set up Font Awesome
library.add(faStar, faSquare, faCheckSquare, faCircleNotch, faCaretDown, faChevronDown, faExclamationTriangle);

class App extends PureComponent {

  componentDidMount() {
    const {
      params,
    } = this.props;

    if (params.paramsValid) {
      this.props.loadSubscriptions();
    }
  }

  // Render the full app with all the subscriptions
  renderFullApp() {
    const {
      params,
      globalOptOutDate,
      disclaimer
    } = this.props;

    // Set up the sub message based on whether the user is unsubscribed to all or not
    let message;
    if (globalOptOutDate === null) {
      message = <p className='sub-message'>{i18n.t('send-emails-to')} {params.email}</p>;
    } else if (globalOptOutDate) {
      message = <p className='sub-message'>{i18n.t('unsubscribed-from-all').replace('[[EMAIL]]', params.email)}</p>;
    }

    // Set up the disclaimer 
    let disclaimerMessage;
    if (disclaimer) {
      disclaimerMessage = <p className='footer-description disclaimer'>{disclaimer}</p>;
    }

    // Set up the content - default if email is not available
    return (
      <div className='app website-subs' >
        <h1>{i18n.t('manage-subscriptions')}</h1>

        {params.paramsValid ?
          <Fragment>
            {message}
            <TabFrame />
            {disclaimerMessage}
          </Fragment>

          : <div className='error-loading'>
            <FontAwesomeIcon
              icon='exclamation-triangle'
              size="2x"
              color='#5b6770'
            />
            <div className='error-loading-text'>{INVALID_EMAIL}</div>
          </div>
        }
      </div >
    );
  }

  // Render a simple single checkbox for the given eloquaName subscription
  renderSingleSubscription(){
    const {
      params,
    } = this.props;

    return <SingleSubscription
      eloquaNames={params.loadEloquaNames}
    />;
  }

  render() {

    const {
      params,
    } = this.props;

    // If a single subscription is to be loaded (stored in params) then 
    // just load that, otherwise load the whole app
    if (params.loadEloquaNames){
      return this.renderSingleSubscription();
    } else {
      return this.renderFullApp();
    }
  }
}

function mapStateToProps(state) {
  return {
    params: state.params,
    globalOptOutDate: state.data.globalOptOutDate,
    disclaimer: state.data.disclaimer,
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadSubscriptions,
  },
)(App));
